export const ROOT_ROUTE = '/';
export const EXPERIMENT_VIEW_ROUTE = 'experiment';
export const BATCH_VIEW_ROUTE = 'batch';
export const TEST_VIEW_ROUTE = 'test';
